// @flow
import { useQuery, type QueryResult } from 'react-query';

import IntlApis from 'common/redux/actions/IntlApis';
import queryClient from 'common/middleware/queryClient';

type Params = {
    clientId: string,
    language: ?string,
    businessUnitId: ?string
};

const queryKey = (params: Params) => {
    return ['i18n', params];
};

export const prefetchI18nStrings = (params: Params): Promise<void> => {
    return queryClient.prefetchQuery({
        queryKey: queryKey(params),
        queryFn: async () => {
            return await IntlApis.fetchI18nStrings(params);
        },
        // fetch only once
        staleTime: Infinity
    });
};

export default function useI18nStrings(params: Params): QueryResult<void> {
    return useQuery({
        queryKey: queryKey(params),
        queryFn: async () => {
            return await IntlApis.fetchI18nStrings(params);
        },
        // NOTE: we assume i18n strings will stay fixed during the lifetime of app,
        // only update strings when user refreshes page
        staleTime: Infinity
    });
}
